<div class="d-flex external-wrapper">
    <div class="d-flex w-100 loading-container" *ngIf="isUrlIdAvailable && !isError">
        <div>
            <mat-spinner></mat-spinner>
        </div>
        <div class="loading-content">Loading Digital Twin...</div>
    </div>
    <div *ngIf="isError" class="d-flex w-100 loading-container">
        <div class="loading-content">Session Expired</div>
    </div>
    <div *ngIf="!isUrlIdAvailable && !isError" class="d-flex w-100 loading-container">
        <div class="loading-content">404 Not Found!</div>
    </div>
</div>